import { Button, Content, Flex, fromTheme, Heading } from '@acsbe/ui';
import { styled } from 'styled-components';

export const ModalImage = styled.img`
  min-height: 233px;

  @media ${fromTheme('viewport.uptoPhablet')} {
    width: 303px;
    min-height: 125px;
  }
`;

export const ModalHeading = styled(Heading)`
  line-height: 1.143;

  @media ${fromTheme('viewport.uptoPhablet')} {
    line-height: 1.6;
  }
`;

export const SFTextButton = styled(Button)`
  font-size: 16px;
  min-height: 44px;
  font-weight: 400;
  line-height: 1.25;
  text-align: center;
  text-transform: capitalize;
  padding: 12px 24px 12px 24px;

  @media ${fromTheme('viewport.uptoPhablet')} {
    font-size: 14px;
    min-height: 36px;
    line-height: 1.43;
    padding: 8px 16px 8px 16px;
  }
`;

export const SFFlex = styled(Flex)`
  font-family: 'SF Pro Text';
  font-style: normal;
`;

export const AbsoluteFlex = styled(Flex)<{
  positionRight?: number | string;
  positionTop?: number | string;
  positionLeft?: string;
  transform?: string;
}>`
  right: ${(props) =>
    props.positionRight !== 'unset' ? `${props.positionRight}px` : 'unset'};
  top: ${(props) =>
    props.positionTop !== 'unset' ? `${props.positionTop}px` : 'unset'};
  left: ${(props) => (props.positionLeft ? props.positionLeft : 'unset')};
  transform: ${(props) => (props.transform ? props.transform : 'unset')};
`;

export const ColorContent = styled(Content)<{ visible?: boolean }>`
  visibility: ${({ visible = true }) => (visible ? 'visible' : 'hidden')};
  color: ${(props) => props.color};
`;

export const CustomSizeContent = styled(Content)<{
  fontSize: number;
  hasColour?: boolean;
}>`
  font-size: ${(props) => props.fontSize}px;
  color: ${(props) => (props.hasColour ? '#075FE4' : '')};
`;

export const BorderedFlex = styled(Flex)<{
  setBorderBottom?: boolean;
  setBackground?: boolean;
}>`
  border-bottom: ${(props) =>
    props.setBorderBottom ? '1px solid #E3E5E8' : 'none'};
  background: ${(props) =>
    props.setBackground ? 'rgba(21, 53, 131, 0.05)' : ''};
`;
